document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.media-gallery', {
    loop: true,

  //  navigation: {
  //     nextEl: "#media-gallery__next-btn",
  //     prevEl: "#media-gallery__prev-btn"
  //   },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });


  const variant_buttons_wrapper = document.querySelector(".product-info__variants-wrapper");

  variant_buttons_wrapper.addEventListener('change', (e) => {
    onVariantButtonSelection(swiper);
  })

});

function onVariantButtonSelection(image_gallery) {
  const variant_buttons = document.getElementsByClassName("product-info__variant-input");

  for (i = 0; i < variant_buttons.length; i++) {
    if (variant_buttons[i].checked) {
      const button_id = variant_buttons[i].id;
      const image_index = parseInt(button_id.charAt(button_id.length - 1));
      image_gallery.slideTo(image_index - 1);
    }
  }
}